/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Budget_MinInputs */

const cs_public_site_demand_budget_min = /** @type {(inputs: Public_Site_Demand_Budget_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpočet od (Kč)`)
};

const en_public_site_demand_budget_min = /** @type {(inputs: Public_Site_Demand_Budget_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget from (CZK)`)
};

/**
* | output |
* | --- |
* | "Budget from (CZK)" |
*
* @param {Public_Site_Demand_Budget_MinInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_budget_min = /** @type {((inputs?: Public_Site_Demand_Budget_MinInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Budget_MinInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_budget_min(inputs)
	return cs_public_site_demand_budget_min(inputs)
});